// import t from "../translations";

const routes = {
  Home: "routes_Home",
  TestLoriini: "routes_TestLoriini",
  User: "routes_User",
  Colors: "routes_Colors",
  Settings: "routes_Settings",
  DeleteAccount: "routes_DeleteAccount",
  ModalTest: "routes_ModalTest",
  Contact: "routes_Contact",
  ContactThankYou: "routes_ContactThankYou",
  LoriiniTest: "routes_LoriiniTest",
  SignIn: "routes_SignIn",
  SignOut: "routes_SignOut",
  SendMessageReset: "routes_SendMessageReset",
  ForgotPassword: "routes_ForgotPassword",
  RegistrationForm: "routes_RegistrationForm",
  Agreement: "routes_Agreement",
  Cookies: "routes_Cookies",
  Privacy: "routes_Privacy",
  Start: "routes_Start",
  EditProfilePage: "routes_EditProfilePage",
  AboutLoriiniApp: "routes_AboutLoriiniApp",
  BlueAboutColorsPage: "routes_BlueAboutColorsPage",
  RedAboutColorsPage: "routes_RedAboutColorsPage",
  YellowAboutColorsPage: "routes_YellowAboutColorsPage",
  GreenAboutColorsPage: "routes_GreenAboutColorsPage",
  KnowladgeColorTheory: "routes_KnowladgeColorTheory",
  KnowladgeHowInterprateResult: "routes_KnowladgeHowInterprateResult",
  KnowladgeWhatIsLoriiniTest: "routes_KnowladgeWhatIsLoriiniTest",
  KnowladgeWaysOfCommunication: "routes_KnowladgeWaysOfCommunication",
  KnowladgeEffectiveCommunication: "routes_KnowladgeEffectiveCommunication",
  KnowladgeManipulation: "routes_KnowladgeManipulation",
  ApplicationLanguage: "routes_ApplicationLanguage",
};
export default routes;
